import { jsx as _jsx } from "react/jsx-runtime";
import { ContextMenu, renderContextMenuItems } from "@air/primitive-context-menu";
import { memo, useMemo, useState } from "react";
import { TableRow } from "~/components/TableView/TableRow/TableRow";
import { useSelectableCard } from "~/hooks/useSelectableCard";
import { useSelectionAwareContextMenuOptions } from "~/hooks/useSelectionAwareContextMenuOptions";
import { leftMouseEvent } from "~/utils/ClickUtils";
const _SelectableTableRow = (param)=>{
    let { item, renderCells, getSelectionMenuOptions, contextMenuOptions, onRowClick, isSelectable, keyboardListenerProps } = param;
    const { isHovering, handleHover, handleUnhover, isSelected, handleItemDoubleClick, confirmItemSelection, preSelectItem, onFocus, onBlur, itemRef: rowRef, isHighlighted } = useSelectableCard({
        item,
        onClick: onRowClick,
        isSelectable
    });
    const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
    const onMouseDown = useMemo(()=>isContextMenuOpen ? undefined : leftMouseEvent(preSelectItem), [
        isContextMenuOpen,
        preSelectItem
    ]);
    const { options } = useSelectionAwareContextMenuOptions({
        id: item.id,
        contextMenuOptions,
        selectionMenuOptions: getSelectionMenuOptions("table-multi-select-context-menu")
    });
    const className = useMemo(()=>{
        const base = isSelected || isHighlighted ? "outline rounded-6 outline-[2px] outline-macaw-300" : "";
        return isHovering ? "".concat(base, " bg-grey-3") : base;
    }, [
        isSelected,
        isHovering,
        isHighlighted
    ]);
    return /*#__PURE__*/ _jsx(ContextMenu, {
        trigger: /*#__PURE__*/ _jsx(TableRow, {
            tabIndex: 0,
            onMouseDown: onMouseDown,
            onClick: confirmItemSelection,
            onDoubleClick: handleItemDoubleClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseEnter: handleHover,
            onMouseMove: handleHover,
            onMouseLeave: handleUnhover,
            ref: rowRef,
            className: className,
            ...keyboardListenerProps,
            children: renderCells({
                isSelected,
                isHovering
            })
        }),
        onOpenChange: (open)=>setIsContextMenuOpen(open),
        children: renderContextMenuItems({
            options
        })
    });
};
export const SelectableTableRow = /*#__PURE__*/ memo(_SelectableTableRow);
